import {
  ADD_SIZER,
  GET_SIZERS,
  DELETE_SIZER,
  EDIT_SIZER,
} from "../../Action/Sizer/sizer";

const initialState = {
  sizer: [],
};

function accountReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_SIZER: {
      return { ...state, sizer: [action.payload, ...state.sizer] };
    }
    case GET_SIZERS: {
      return { ...state, sizer: action.payload };
    }
    case DELETE_SIZER: {
      const after_delete_sizer = state.sizer.filter(
        (sizer) => sizer.sizer_id !== action.payload.sizer_id
      );
      return { ...state, sizer: after_delete_sizer };
    }
    case EDIT_SIZER: {
      let NewSizer = state.sizer.map((item) =>
        item.sizer_id === action.payload.sizer_id ? action.payload : item
      );

      return {
        ...state,
        sizer: NewSizer,
      };
    }
    default:
      return state;
  }
}

export default accountReducer;
